import { Stack, Typography } from "@mui/material"

const LABEL_SX = { color: "text.secondary", fontWeight: 600, letterSpacing: 0.5 }

export function LegislationDetailField({ label, children }) {
    return (
        <Stack spacing={0.5}>
            <Typography variant="overline" sx={LABEL_SX}>
                {label}
            </Typography>
            {children}
        </Stack>
    )
}
